import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row
} from 'reactstrap';

import {
    error,
    NO_DATA_FOUND,
    selectOption,
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {
    ButtonAdd2,
    ButtonCancel2,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import {productProvider} from "../../../providers/productProvider";
import BootstrapTable from "react-bootstrap-table-next";
import SelectGeneric from "../../../components/select/selectGeneric";
import { xailingRoutProductService } from "../../../jwt/_services/xailing/xailingRoutProductService";
import {TT_DELETE} from "../../../components/i18n/toolTips";

export const XailingRoutProductModal = forwardRef((props, ref) => {

    // Form const
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [xailingRout, setXailingRout] = useState(props.item);
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);

    // Multiproduct const
    const [listItems, setListItems] = useState([]);
    const [productId, setProductId] = useState(null);

    useEffect(() => {
        if (xailingRout)
            refreshDataList(xailingRout);
    }, []);

    const refreshDataList = (_xailingRout) => {
        setLoading(true);
        setXailingRout(_xailingRout);
        xailingRoutProductService.listChilds(_xailingRout)
            .then(result => {
                if (result){
                    setListItems(result);
                } else {
                    setListItems([]);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                showToastCustom(error, errorMessage);
            });
    }

    // ----------------------------------------------
    //            FORM BEHAVIOR
    // ----------------------------------------------
    const showModal = () => {
        setModal(!modal);
    }

    useImperativeHandle(ref, () => ({
        showModal(_product) {
            setModal(!modal);
            refreshDataList(_product);
        }
    }));

    // ----------------------------------------------
    //            ADD/REMOVE CHILDS
    // ----------------------------------------------
    const removeChild = (data) => {
        setLoading(true);

        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                id : data.id
            }
        };

        xailingRoutProductService.removeChild(dataRequest)
            .then(_ => {
                refreshDataList(xailingRout);
            })
            .catch(_ => {
                setLoading(false);
            });
    }

    const addChild = () => {
        if (productId === null || productId === undefined || productId === '') {
            return showToastCustom(error, selectOption);
        }
        setLoading(true);
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                xailingRout : { id : xailingRout.id },
                product : { id : productId }
            }
        };
        xailingRoutProductService.addChild(dataRequest)
            .then(_ => {
                refreshDataList(xailingRout);
            })
            .catch(_ => {
                setLoading(false);
            });
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => removeChild(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'sivexId',
        text: 'ID Sivex',
    }, {
        dataField: 'sivexCode',
        text: 'Codigo Sivex',
    }, {
        dataField: 'name',
        text: 'Nombre',
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '80px'},
        formatter: actionsFormatter
    }];

    return (
        <Modal
            isOpen={modal}
            toggle={showModal}
        >
            <ModalHeader toggle={showModal}>
                <i className="fas fa-box-open mr-2"/>
                Productos de la ruta { '[' + xailingRout?.code + ']' }
            </ModalHeader>
            <ModalBody  >
                <Card>
                    {loading && showLoader()}
                    <CardBody>
                        <Form >
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Producto</Label>
                                        <SelectGeneric
                                            initialValue={ productId }
                                            setExternalValue={ setProductId }
                                            provider = { productProvider }
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <CardBody className="border-top">
                                <div className="float-right">
                                    <ButtonAdd2 onClick={addChild}/>
                                    <ButtonCancel2 onClick={showModal}/>
                                </div>
                            </CardBody>
                        </Form>
                    </CardBody>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-box-open mr-2"/>
                    </CardTitle>
                    <CardBody className="border-top">
                        <BootstrapTable
                            striped hover
                            tableHeaderClass='mb-0'
                            remote
                            keyField="id"
                            data={listItems}
                            noDataIndication={NO_DATA_FOUND}
                            columns={columns}
                        />
                    </CardBody>
                </Card>

            </ModalBody>
        </Modal>
    )
})